// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroTwoToneSvg from "@ant-design/icons-svg/es/asn/EuroTwoTone";
import AntdIcon from '../components/AntdIcon';

var EuroTwoTone = function EuroTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroTwoToneSvg
  }));
};

EuroTwoTone.displayName = 'EuroTwoTone';
export default React.forwardRef(EuroTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EuroTwoTone.js
// module id = 1027
// module chunks = 0